import React, { FC } from 'react';

import PartnerOffers from 'buyside/components/presentation/PartnerOffers/partnerOffers';

const PartnerOffersPageRoot: FC = () => {
  return <PartnerOffers />;
};

export default PartnerOffersPageRoot;
